export const GET_CANCELLATION_POLICY_CACHE_KEY = 'get-cancellation-policy'
export const GET_LATE_CANCEL_COUNTS_CACHE_KEY = 'get-late-cancel-counts'
